import { post } from './glosbe-dictionary-api-helper';
export function addTranslation(data) {
    /*
    TODO
        if (this.settingsService.developerTools) {
            params['all'] = true;
        }
        */
    return post({
        endpoint: 'add/translation',
        data, options: { credentials: 'include' }
    });
}
